<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
    class="left-sidebar">
    <v-layout
      justify-center
      wrap>
    <v-flex
        md12>
      <!-- edit category dialog -->
        <v-dialog
            v-model="editCategoryDialog"
            persistent
            max-width="400"
            content-class="dialog-color"
        >
          <v-card-title class="text-h6">
             {{ $t('users.users')}}
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
          <v-form ref="editCategoryForm">
            <v-row class="dialog-card-body">
            <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="editCategoryName"
                  :label="$t('categories.name')"
                  :placeholder="$t('categories.name')"
                  :error-messages="editCategoryNameErrors"
                />
              <input id="edit-category-image" type='file' accept="image/*"/><br>
              <img id="editCategoryImage">
            </v-col>
            </v-row>
        </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="add-new mb-1 mt-8 mr-3"
              dark
              @click="cancelEditCategory()"
              >
              {{ $t('cancel')}}
            </v-btn>
            <v-btn
              class="add-new mb-1 mt-8 mr-3"
              dark
              @click="editCategory()">
              {{ $t('submit')}}
            </v-btn>
          </v-card-actions>
      </v-dialog>
        <v-card
        elevation="2"
        class="card-body">
        <v-card>
            <v-card-title>{{ $t('orders.orders')}}</v-card-title>
        </v-card>
        <v-spacer/>
        <div>
        <v-btn
            dark
            class="add-new mb-1 mt-8 mr-3"
            @click="openNewUser()">{{ $t('orders.newOrder') }}</v-btn>
        </div>
          <v-text-field
            v-model="search"
            :search="search"
            :label="$t('search')"
            :placeholder="$t('search')"
            single-line
            hide-details
            class="search-field">
            </v-text-field>
            <v-data-table
              :headers="headers"
              :items="getCategories"
              :rows-per-page-items ="rowsAmount"
              :search="search"
              class="elevation-1"
            >
              <template v-slot:item="props">   
                <tr>    
                <td class="justify-center icon-table-wrap">
                      <v-icon
                          medium
                          class="icon-table"
                          @click="openEditCategory(props)">mdi-pencil</v-icon>
                  </td>
                  <td class="justify-center icon-table-wrap">
                      <v-icon
                          medium
                          class="icon-table"
                          @click="deleteOrder(props)">mdi-delete</v-icon>
                  </td>       
                  <td class="pointer" :title="$t('categories.openSubcategory')">
                    <div>{{ props.item.name }}</div>
                  </td>             
                  <!-- <td>
                    <div v-if="props.item.image">
                        <img class="table-image" v-bind:src=props.item.image>
                    </div>
                    <div v-else>---</div>
                  </td>  -->
                  <td>
                    <div v-if="props.item.sku">{{ props.item.sku }}</div>
                    <div v-else>/</div>
                  </td>  
                  <td>
                    <div>{{ props.item.product_count }}</div>
                  </td> 
                  <td>
                    <div>{{ props.item.position }}</div>
                  </td> 
                </tr>             
              </template>
            </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {  mapGetters } from 'vuex';
  import { required } from 'vuelidate/lib/validators'
  import i18n from '../../i18n'
  export default {
      data () {
          return {
              search: '',
              editCategoryDialog: false,
              editCategoryName: '',
              rowsAmount: [10,20,25,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
              headers: [
                  { text: i18n.t(''),},
                  { text: i18n.t(''),},
                  { text: i18n.t('order.data1'), value: 'name'},
                //   { text: i18n.t('categories.image'), value: 'image'},
                  { text: i18n.t('order.data2'), value: 'sku'},
                  { text: i18n.t('order.data3'), value: 'product_count'},
                  { text: i18n.t('order.data4'), value: 'position'},
              ],
          }
      },
      validations: {
          editCategoryName: { required }
      },
      computed: {
        ...mapGetters([
            'getAllCategories',
            'getCategory',
            'getAllProducts'
        ]),
        getCategories(){
            let categories = [];
                this.getAllCategories.forEach(el => {
                if(el.parent_id === null){
                    categories.push(el);
                }            
            });
            return categories;
        },
        editCategoryNameErrors(){
            const errors = [];
                if (!this.$v.editCategoryName.$dirty) return errors;
                    !this.$v.editCategoryName.required && errors.push(i18n.tc('fieldRequired'));
                return errors;
        },
      },
      methods:{
        openNewUser(){
        //   this.$router.push(`/${i18n.locale}/categories/add-new-category`);
        },
        cancelEditCategory(){
            this.editCategoryDialog = false;
            this.resetEditCategoryForm();
        },
        resetEditCategoryForm(){
            this.$refs.editCategoryForm.reset();
            this.$v.$reset();
            document.getElementById('edit-category-image').value = '';
        },
        // openEditCategory(props){
        //    localStorage.setItem('categoryId', props.item.id)
        //    this.$router.push(`/${i18n.locale}/categories/edit-category/${props.item.id}`);
        // },
        deleteOrder(props){
            if (confirm(i18n.t(`areYouSureToDelete_`) + `${props.item.name}?`)) {
            //   this.$store.dispatch('DELETE_CATEGORY', props.item.id)
            //       .then(() => this.$store.dispatch('LOAD_ALL_CATEGORIES'));
            }
        },
      },
      beforeCreate() {
          this.$store.dispatch('LOAD_ALL_CATEGORIES'); 
          this.$store.dispatch('LOAD_ALL_PRODUCTS');
      },
      mounted() {
          this.$store.dispatch('LOAD_ALL_CATEGORIES');
          this.$store.dispatch('LOAD_ALL_PRODUCTS');
      },
  }
</script>

<style lang="less" scoped>

</style>